import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismButton, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { BillingAdmin } from 'frontend-payments/models';

import styles from './td-actions.module.css';

interface BillingAdminCellsTdActionsSignature {
  Args: {
    column: {
      onEditUser: (billingAdmin: BillingAdmin) => void;
      onRemoveUser: (billingAdmin: BillingAdmin) => void;
    };
    value: {
      billingAdmin: BillingAdmin;
      isStaffUser: boolean;
      showEditButton: boolean;
      showRemoveButton: boolean;
    };
  };
}

export default class BillingAdminCellsTdActions extends Component<BillingAdminCellsTdActionsSignature> {
  @action
  onEditUser(): void {
    this.args.column.onEditUser(this.args.value.billingAdmin);
  }

  @action
  onRemoveUser(): void {
    this.args.column.onRemoveUser(this.args.value.billingAdmin);
  }

  <template>
    <div class="flex justify-end gap-100">
      {{#if @value.billingAdmin.errorMessage}}
        <p class="text-200--regular">{{@value.billingAdmin.errorMessage}}</p>
      {{else}}
        {{#if @value.billingAdmin.isSaving}}
          <div class="flex gap-100">
            <PrismIcon
              @name="sync"
              @size="small"
              class={{styles.animate-spin-reverse}}
            />
            <p class="text-200--regular">{{t "payments.processing"}}</p>
          </div>
        {{else}}
          {{#if @value.showEditButton}}
            <PrismButton
              @buttonType="secondary"
              @icon="edit-pencil"
              @isDisabled={{@value.isStaffUser}}
              @onClick={{this.onEditUser}}
              @size="small"
              data-test-edit-user-button={{@value.billingAdmin.id}}
            />
          {{/if}}
          {{#if @value.showRemoveButton}}
            <PrismButton
              @buttonType="secondary"
              @icon="bin"
              @isDisabled={{@value.isStaffUser}}
              @onClick={{this.onRemoveUser}}
              @size="small"
              data-test-remove-user-button={{@value.billingAdmin.id}}
            />
          {{/if}}
        {{/if}}
      {{/if}}
    </div>
  </template>
}
